import React from "react";
import { STATUS_COLORS, PRIORITY_COLORS } from "../../lib/utils";

export function StatusBadge({ status }) {
  const color = STATUS_COLORS[status] || "#6B7280";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border"
      style={{
        color,
        backgroundColor: `${color}12`,
        borderColor: `${color}33`,
      }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: color }} />
      {status}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const color = PRIORITY_COLORS[priority] || "#6B7280";
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className="inline-flex items-center justify-center w-6 h-6 rounded-md text-[11px] font-bold"
      style={{ color, backgroundColor: `${color}18`, border: `1px solid ${color}40` }}
    >
      {priority}
    </span>
  );
}
